import { hasSanityConfig, sanity } from './sanity';

export const STAFF_QUERY = `*[_type == "staff"] | order(featured desc, sortOrder asc) {
  _id,
  name,
  title,
  photo,
  featured,
  sortOrder,
}`;

export const FALLBACK_STAFF = [
  {
    _id: 'fallback-kath-langwood',
    name: 'Kath Langwood',
    title: 'Founder & Lead Tutor',
    photo: null,
    featured: true,
    sortOrder: 0,
  },
  {
    _id: 'fallback-langwood-educators',
    name: 'Langwood Educators',
    title: 'Experienced literacy, numeracy, and science tutors',
    photo: null,
    featured: false,
    sortOrder: 1,
  },
];

export function normalizeStaffMember(member, index = 0) {
  const parsedSortOrder = Number(member?.sortOrder);

  return {
    _id: member?._id || `staff-${index}`,
    name: typeof member?.name === 'string' && member.name.trim() ? member.name.trim() : 'Langwood Tutor',
    title: typeof member?.title === 'string' ? member.title.trim() : '',
    photo: member?.photo ?? null,
    featured: Boolean(member?.featured),
    sortOrder: Number.isFinite(parsedSortOrder) ? parsedSortOrder : index,
  };
}

export function sortStaffMembers(a, b) {
  if (a.featured !== b.featured) {
    return Number(b.featured) - Number(a.featured);
  }

  if (a.sortOrder !== b.sortOrder) {
    return a.sortOrder - b.sortOrder;
  }

  return a.name.localeCompare(b.name);
}

export function getFallbackStaff() {
  return FALLBACK_STAFF.map((member, index) => normalizeStaffMember(member, index));
}

export async function fetchStaff({ client = sanity } = {}) {
  if (!hasSanityConfig || typeof client?.fetch !== 'function') {
    return {
      staff: getFallbackStaff(),
      error: new Error('Sanity is not configured.'),
      isFallback: true,
    };
  }

  try {
    const response = await client.fetch(STAFF_QUERY);
    const staff = Array.isArray(response)
      ? response.map((member, index) => normalizeStaffMember(member, index)).sort(sortStaffMembers)
      : [];

    return {
      staff,
      error: null,
      isFallback: false,
    };
  } catch (error) {
    return {
      staff: getFallbackStaff(),
      error,
      isFallback: true,
    };
  }
}
